import DataLoader from 'components/DataLoader';
import Component from 'containers/Tooltip/Component';
import React, {FC} from 'react';
import {makeReadConfigurator} from 'utils/makeConfigurator';

export type TTooltipCur = {
  type: 'WORD';
  id: string;
  target?: HTMLElement | SVGElement;
} & {
  type: 'WORD';
  word: string;
};

export type Props = {
  cur: TTooltipCur | null;
};

const Tooltip: FC<Props> = ({cur}) => {
  const conf = makeReadConfigurator({});
  return (
    <DataLoader<{}> urls={{}}>
      {(data: {}) => <Component data={data} conf={conf} cur={cur} />}
    </DataLoader>
  );
};

export default Tooltip;
